import { request } from "../http";
import {
  ensureArrayOfStrings,
  ensureBoolean,
  ensureNumber,
  ensureObject,
  ensureString,
} from "../validate";
import type { NewsletterParams } from "./newsletter";
import { privacyConsent, type PrivacyConsentParams } from "./privacy";

const FN = "GZIntegracoes.v1.sendQuizAll";

const QUIZ_ALL_UPSERT_URL =
  "https://tbcwr0ax1k.execute-api.us-east-1.amazonaws.com/prod/quiz-all-upsert";

const CLIENT_ID = "xaq57q5k0rvkfmfyb4u3phc2";
const CLIENT_SECRET = "Tc0DJm0bieWX1rRQ1QsqFH9s";
const GRANT_TYPE = "client_credentials";
const DATA_EXTENSION_KEY = "ACDCCE65-2E87-4CE3-AA7D-3AFE918BF341";

export interface SendQuizAllParams {
  email: string;
  slugQuiz: string;
  slugQuestion: string;
  valor: string;
  newsletter?: NewsletterParams;
  consent?: Omit<PrivacyConsentParams, "holder"> | null;
}

export async function sendQuizAll(params: SendQuizAllParams): Promise<boolean> {
  ensureObject(params, `${FN}(params)`);
  ensureString(params.email, `${FN} → params.email`);
  ensureString(params.slugQuiz, `${FN} → params.slugQuiz`);
  ensureString(params.slugQuestion, `${FN} → params.slugQuestion`);
  ensureString(params.valor, `${FN} → params.valor`);

  if (params.newsletter !== undefined) {
    ensureObject(params.newsletter, `${FN} → params.newsletter`);
    ensureNumber(params.newsletter.pubListId, `${FN} → params.newsletter.pubListId`);
    ensureBoolean(params.newsletter.receber, `${FN} → params.newsletter.receber`);
    ensureString(params.newsletter.code, `${FN} → params.newsletter.code`);
  }

  if (params.consent !== undefined && params.consent !== null) {
    ensureObject(params.consent, `${FN} → params.consent`);
    if (params.consent.hashes !== undefined) {
      ensureArrayOfStrings(params.consent.hashes, `${FN} → params.consent.hashes`);
    }
    if (params.consent.metadata !== undefined && params.consent.metadata !== null) {
      ensureObject(params.consent.metadata, `${FN} → params.consent.metadata`);
    }
  }

  const body = {
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    grant_type: GRANT_TYPE,
    data_extension_key: DATA_EXTENSION_KEY,
    dados: [
      {
        keys: {
          email: params.email,
          slug_quiz: params.slugQuiz,
          QUESTION: params.slugQuestion,
        },
        values: {
          usuario_id: params.email,
          cpf_user_logado: null,
          OPT01: params.valor,
          newsletter_pub_list_id: params.newsletter?.pubListId ?? null,
          newsletter_receber: params.newsletter?.receber ?? false,
          newsletter: params.newsletter?.code ?? null,
        },
      },
    ],
  };

  const apiPromise = request(QUIZ_ALL_UPSERT_URL, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });

  const consentPromise: Promise<boolean> = params.consent
    ? privacyConsent({ ...params.consent, holder: params.email })
    : Promise.resolve(true);

  const [apiOk, consentOk] = await Promise.all([apiPromise, consentPromise]);
  return apiOk && consentOk;
}
